.rasa-link-button {
  display: inline-flex;
  height: 32px; // Adjusted height to account for border
  padding: 8px 12px; // Adjusted padding to maintain total height of 50px
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: middle;
  border-radius: 8px;
  border: 1px solid var(--message-button-border-color);
  background-color: var(--message-button-background-color);
  color: var(--message-button-color);
  font-family: var(--font-family);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 0.3px;
  padding-top: 6px;
  padding-bottom: 6px;
  white-space: nowrap;
  cursor: pointer;
  box-sizing: border-box; // Ensure padding and border are included in height calculation

  &--selected {
    background-color: var(--message-selected-button-background-color);
    color: var(--message-selected-button-color);
    border: 1px solid var(--message-selected-button-border-color);
  }

  &-icon-right {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    height: 16px;
  }
}
